import { getProxyUrl } from '.'

export async function saveImageToProject(
  image: string,
  idVersiones: number,
  nombre: string = '2D',
): Promise<boolean> {
  const url = getProxyUrl('api/Diseno/guardarvn')

  const nameVN = nombre || '2D'

  // ESTRATEGIA: Eliminar TODAS las imágenes 2D existentes antes de guardar la nueva
  // Esto evita duplicados y asegura que solo haya una imagen 2D
  let existingIdHqrenders: number | null = null
  let imagenes2D: any[] = []

  try {
    const { getProxyUrl } = await import('.')
    const verifyUrl = getProxyUrl(`api/Diseno/getvisualesnombradas/${idVersiones}`)
    const verifyResponse = await fetch(verifyUrl, {
      headers: {
        'Accept-Language': 'ES',
        'Content-Type': 'application/json',
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    })

    if (verifyResponse.ok) {
      const verifyText = await verifyResponse.text()
      const visuales = JSON.parse(verifyText)

      // Buscar TODAS las imágenes que contengan '2D' en el nombre
      imagenes2D = Array.isArray(visuales)
        ? visuales.filter((v: any) => v.nombre && v.nombre.includes('2D'))
        : []

      // PASO 1: Eliminar TODAS las imágenes 2D que tienen idHqrenders válido
      // Esto incluye imágenes con nombre exacto '2D' y también las que tienen timestamp
      const imagenesConIdHqrenders = imagenes2D.filter(
        (v: any) => v.idHqrenders !== null && v.idHqrenders !== undefined,
      )

      if (imagenesConIdHqrenders.length > 0) {
        for (const img of imagenesConIdHqrenders) {
          try {
            const deleteUrl = getProxyUrl(`api/HQRender/borrarrender/${img.idHqrenders}`)
            await fetch(deleteUrl, {
              method: 'GET',
              headers: {
                Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
              },
            })
          } catch (error) {
            // Error silencioso al eliminar imagen
          }
        }
      }

      // PASO 2: Buscar si hay una imagen con nombre exacto '2D' y idHqrenders válido para actualizar
      // (después de eliminar, puede que ya no exista)
      const imagenExactaConIdHqrenders = imagenes2D.find(
        (v: any) => v.nombre === nameVN && v.idHqrenders !== null && v.idHqrenders !== undefined,
      )

      if (imagenExactaConIdHqrenders) {
        // Si encontramos una imagen exacta con idHqrenders válido, la usaremos para actualizar
        existingIdHqrenders = imagenExactaConIdHqrenders.idHqrenders
      }

      // Esperar un poco después de eliminar para que el backend procese las eliminaciones
      if (imagenesConIdHqrenders.length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 500))
      }
    }
  } catch (error) {
    // Error silencioso al obtener imagen existente
  }

  // Construir el payload
  const visualNombradaPayload: any = {
    imageUrl: image,
    nombre: nameVN,
  }

  // Solo incluir idHqrenders si tiene un valor válido (para actualizar)
  if (existingIdHqrenders !== null && existingIdHqrenders !== undefined) {
    visualNombradaPayload.idHqrenders = existingIdHqrenders
  }
  // Si es null, no lo incluimos para que el backend intente reemplazar por nombre

  const payload = {
    idVersiones,
    visualNombrada: visualNombradaPayload,
  }

  const params: RequestInit = {
    method: 'POST',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
    body: JSON.stringify(payload),
  }

  try {
    const response = await fetch(url, params)

    if (response.ok) {
      return true
    } else {
      return false
    }
  } catch (error) {
    return false
  }
}
